import { Link } from 'react-router-dom'
import styles from './Folder.module.css'

function Folder({ href, name }: { href: string; name: string }) {
  return (
    <Link className={styles.folder} to={href}>
      <img className={styles.icon} src="/folder.svg" alt="" />
      <span className={styles.name}>{name}</span>
    </Link>
  )
}

export default Folder
